import { useState } from "react";
import { SearchLogHistory } from "../../axios";
import DateControl from "./DateControl";

interface Props {
	onSearch: (search: SearchLogHistory) => void,
};

/**
 * ログ履歴検索条件用コンポーネント
 * 
 * @returns 
 */
export default function ArchiveCondition(props: Props): JSX.Element {

	/** 検索履歴 */
	const [searchLogHistory, setSearchLogHistory] = useState<SearchLogHistory>({});

	/** 表示更新用キー */
	const [key, setKey] = useState<number>(Date.now());

	/**
	 * 作成日_from変更イベント
	 * 
	 * @param value 
	 */
	const handleSendDateFromChange = (value?: string) => {
		searchLogHistory.create_date_from = value;
	};

	/**
	 * 作成日_to変更イベント
	 * 
	 * @param value 
	 */
	const handleSendDateToChange = (value?: string) => {
		searchLogHistory.create_date_to = value;
	};

	/**
	 * 検索ボタンクリック時イベント
	 */
	const handleSearchClick = async () => {
		if (validate(searchLogHistory) == false) {
			return;
		}
		props.onSearch({ ...searchLogHistory });
	};

	/**
	 * クリアボタンクリック時イベント
	 */
	const handleClearClick = async () => {
		setSearchLogHistory({});
		setKey(Date.now());
	};

	/**
	 * フォームの内容をチェックする。
	 * 
	 * @param logHistory 
	 * @returns 
	 */
	const validate = (searchLogHistory: SearchLogHistory) => {
		if (searchLogHistory.create_date_from == '--------') {
			alert('作成日の開始日の指定が正しくありません。');
			return false;
		}
		if (searchLogHistory.create_date_to == '--------') {
			alert('作成日の終了日の指定が正しくありません。');
			return false;
		}
		return true;
	};

	// 描画する
	return (
		<>
			<h5>ファイル検索&nbsp;</h5>
			<div className="control-group" key={key}>
				<div>
					<table width="100%" className="hyosearch">
						<tbody>
							<tr>
								<td scope="row">作成日</td>
								<td scope="row" colSpan={3}>
									<div>
										<DateControl onChange={handleSendDateFromChange} />～&nbsp;
										<DateControl onChange={handleSendDateToChange} />
									</div>
								</td>
							</tr>
							
						</tbody>
					</table>
				</div>
			</div>
			<div className="control-group">
				<div className="controls">
					<button className="btn btn-default btn-primary pull-center" type="button" onClick={handleSearchClick}>検索</button>&nbsp;
					<button className="btn btn-default btn-secondary pull-center" type="button" onClick={handleClearClick}>クリア</button>
				</div>
			</div>
		</>
	);

}
